export default "__VITE_ASSET__DIDt8gb7__"